import Node from '../node.js';
import { PARAM_TYPE } from '../connector.js';

export default class NodeSubdivideMesh extends Node
{
	constructor(pParent)
	{
		super(pParent);

		this.addInput(PARAM_TYPE.GEOMETRY, 'geo', null);

		this.addInput(PARAM_TYPE.INTEGER, 'subdiv_levels', 2, { minValue: 1, maxValue: 8 });

		this.addOutput(PARAM_TYPE.GEOMETRY, 'geo');
	}

	getType()
	{ 
		return 'subdivideMesh';
	}

	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{
		let pGeoList = inputValues['geo'];
		if(!pGeoList)
			return null;

		for(let pSrcMesh of pGeoList)
		{
			if(!pSrcMesh)
				continue;

			// TODO: N/A in BJS 2.5
			pSrcMesh.increaseVertices(inputValues['subdiv_levels']);
		}

		return pGeoList;
	}
}